import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import { getFirebaseBackend } from 'src/app/authUtils';
import { Date_range } from 'src/app/core/models/date-range';
import { BillingService } from 'src/app/services/billing/billing.service';
import { LeadService } from 'src/app/services/lead/lead.service';
import { OrdersService } from 'src/app/services/orders/orders.service';
import { SelectedOptionsService } from 'src/app/services/selected-options-service/selected-options.service';
import { UserService } from 'src/app/services/user/user.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { APPT_TYPES, QC_COLUMNS } from 'src/app/shared/constants';
import { ColumnConfig } from 'src/app/shared/new-column-selector/new-column-selector.component';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-new-qc',
	templateUrl: './new-qc.component.html',
	styleUrls: ['./new-qc.component.scss'],
})
export class NewQcComponent implements OnInit {
	public leadsLoading: boolean;
	public leads: any[];
	public unreviewed: any[];
	public overproduced: any[];
	public approved: any[];
	public denied: any[];
	public fix: any[];
	public leadTab: string;
	public activeTab: string;
	public totalApproved: number;
	public totalDenied: number;
	public totalFix: number;

	public totalOverproduced: number;
	public totalUnreviewed: number;

	public leadsMsg: any;
	public unreviewedLeadsMsg: any[];
	public approvedLeadsMsg: any[];
	public rescheduleLeadsMsg: any[];
	public deniedLeadsMsg: any[];

	public roles = ['superAdmin', 'admin', 'floor', 'ae'];

	public perms = {
		adminRole: () => 'admin',
	};

	public ROLE_LABELS: any = {
		superAdmin: 'Super Admin',
		admin: 'Admin',
		floor: 'Floor Manager',
		ae: 'AE',
	};

	public currentTab = 'review';

	public tab = () => this.currentTab;

	public fromDate: NgbDate | null;
	public toDate: NgbDate | null;

	// columns = QC_COLUMNS;

	public defaultcolumns: ColumnConfig[] = [
		{ name: 'Id', prop: 'id', visible: true },
		{ name: 'Prospect', prop: 'prospect', visible: true },
		{ name: 'Campaign', prop: 'campaign', visible: true },
		{ name: 'Creation Date', prop: 'creation_date', visible: true },
		{ name: 'Appointment', prop: 'appointment', visible: true },
		{ name: 'Creation Date', prop: 'creation_date', visible: true },
		{ name: 'Phone', prop: 'phone', visible: true },
		{ name: 'Warm-call', prop: 'warmcall', visible: true },
		{ name: 'Status', prop: 'status', visible: true },
		{ name: 'Difficulty', prop: 'difficulty', visible: true },
		{ name: 'Billed', prop: 'billed', visible: true },
	];

	public timeInStatusColumn: ColumnConfig = { name: 'Change Date', prop: 'change_date', visible: false };
	public freeTypeColumn: ColumnConfig = { name: 'Free Type', prop: 'free_type', visible: false };
	public confirmationColumn: ColumnConfig = { name: 'Confirmation', prop: 'confirmation', visible: false };

	public extraColumns: ColumnConfig[] = QC_COLUMNS.filter((c) => !['prospect_company', 'replacement_status', 'id', 'date_generated', 'lead_creation', 'primary_phone', 'prospect_name', 'meet_type', 'difficult', 'campaign_name', 'payed', 'change_date', 'free_type', 'confirmation'].includes(c.prop)).map((c) => ({ name: c.name, prop: c.prop, visible: false }));
	public columns: ColumnConfig[] = [...this.defaultcolumns, this.timeInStatusColumn, this.freeTypeColumn, this.confirmationColumn, ...this.extraColumns];

	public centeredColumns: string[] = ['employee_size', 'zip', 'state', 'calificado', 'replace_for', 'replaced_by', 'time_zone', 'generated_by', 'free_type', 'confirmation', 'payed', 'difficult', 'primary_phone'];

	public searchTerm = '';

	public dateRange_: Date_range = {
		dateStart: dayjs(new Date()),
		dateEnd: dayjs(new Date()),
	};

	selectedLead: any = null;
	fixReason = '';
	selectedDisposition = '';

	dispositions = ['charge', 'paid', 'reserve', 'promo', 'hourly'];
	dispositionLabels: any = {
		charge: 'Charge — bill at CPL',
		paid: 'Free · Paid',
		reserve: 'Free · Reserve (prepaid credit)',
		promo: 'Free · Promo (comp)',
		hourly: 'Free · Hourly',
	};

	aiTriage = {
		score: 62,
		verdict: 'Borderline — needs eyes',
		reasons: [
			{ text: 'Contact reached but title unclear (gatekeeper?)', positive: false },
			{ text: 'Notes thin — no employee count or pain point', positive: false },
			{ text: 'Warm-call confirmation FAILED — no answer x2', positive: false },
		],
		flags: ['Possible non-DM', 'Notes under 15 words', 'Confirmation failed'],
	};
	user: any;

	constructor(
		private leadSrv: LeadService,
		public selectedOptions: SelectedOptionsService,
		public utils: UtilsService,
		private sanitizer: DomSanitizer,
		private calendar: NgbCalendar,
		private route: ActivatedRoute,
		private router: Router,
		private orderSrv: OrdersService,
		private billingSrv: BillingService,
		private userSrv: UserService,
	) {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.selectedOptions.qcControl.agent = 'All';

		if (this.selectedOptions.qcControl.fromDate === '' && this.selectedOptions.qcControl.toDate === '') {
			const today = this.calendar.getToday();
			this.fromDate = new NgbDate(today.year, 1, 1);
			this.toDate = today;

			this.dateRange_ = {
				dateStart: dayjs(this.utils.ngbDateToPHP(this.fromDate)),
				dateEnd: dayjs(this.utils.ngbDateToPHP(this.toDate)),
			};

			this.selectedOptions.qcControl.fromDate = this.utils.ngbDateToPHP(this.fromDate) + '00:00:00';
			this.selectedOptions.qcControl.toDate = this.utils.ngbDateToPHP(this.toDate) + '23:59:59';
		} else {
			const fromDate_ = new Date(this.selectedOptions.qcControl.fromDate);
			this.fromDate = new NgbDate(fromDate_.getFullYear(), fromDate_.getMonth() + 1, fromDate_.getDate());

			const toDate_ = new Date(this.selectedOptions.qcControl.toDate);
			this.toDate = new NgbDate(toDate_.getFullYear(), toDate_.getMonth() + 1, toDate_.getDate());

			this.dateRange_ = {
				dateStart: dayjs(this.selectedOptions.qcControl.fromDate),
				dateEnd: dayjs(this.selectedOptions.qcControl.toDate),
			};
		}
	}

	ngOnInit() {
		this.applyFiltersFromUrl();
		this.syncUrl();
		this.selectSearch();
	}

	trackByRole(index: number, role: any): any {
		return role;
	}

	selectSearch() {
		this.leadsLoading = true;
		this.leads = [];
		this.unreviewed = [];
		this.approved = [];
		this.denied = [];
		this.fix = [];
		this.overproduced = [];
		this.activeTab = 'leads';

		this.leadSrv.selectSearch(this.selectedOptions.qcControl).subscribe((data: any) => {
			for (let lead of data.body) {
				// lead.meet_type = this.utils.getTypesIcons(lead.meet_type);
				if (lead.free_type == '' || lead.free_type == null) {
					lead.free_type = '-';
				}

				if (lead.lead_status == 'Approved') {
					switch (lead.replacement_status) {
						case 'Approved':
							lead.class = {
								class: 'bg-success',
								key: 'prospect_company',
							};
							break;
						case 'Replaced':
							lead.class = {
								class: 'bg-purple',
								key: 'prospect_company',
							};
							break;
						case 'Rescheduled':
							lead.class = {
								class: 'bg-grey-dark',
								key: 'prospect_company',
							};
							break;
						case 'Pending Replacement':
							lead.class = {
								class: 'bg-purple-light',
								key: 'prospect_company',
							};
							break;
						case 'Pending Reschedule':
							lead.class = {
								class: 'bg-grey-light',
								key: 'prospect_company',
							};
							break;
						case 'QC Calls':
							lead.class = {
								class: 'bg-oliva',
								key: 'prospect_company',
							};
							break;

						default:
							lead.class = {
								class: 'bg-success',
								key: 'prospect_company',
							};
							break;
					}
					lead.stage = 'released';
					this.approved.push(lead);
				} else if (lead.lead_status == 'Denied') {
					lead.class = {
						class: 'bg-danger',
						key: 'prospect_company',
					};
					this.denied.push(lead);
				} else if (lead.lead_status == 'Fix') {
					lead.class = {
						class: 'bg-warning',
						key: 'prospect_company',
					};
					this.fix.push(lead);
				}

				if (lead.payed == 'T') {
					lead.payed = this.sanitizer.bypassSecurityTrustHtml(`<i class="ri-checkbox-line"></i>`);
				} else {
					lead.payed = this.sanitizer.bypassSecurityTrustHtml(`<i class="ri-checkbox-blank-line"></i>`);
				}

				switch (lead.difficult) {
					case 'Easy':
						lead.difficult = this.sanitizer.bypassSecurityTrustHtml(`<i class="ri-flag-2-fill text-success" aria-hidden="true"></i>`);
						break;
					case 'Medium':
						lead.difficult = this.sanitizer.bypassSecurityTrustHtml(`<i class="ri-flag-2-fill text-warning" aria-hidden="true"></i>`);
						break;

					case 'Hard':
						lead.difficult = this.sanitizer.bypassSecurityTrustHtml(`<i class="ri-flag-2-fill text-danger" aria-hidden="true"></i>`);
						break;

					default:
						break;
				}

				if (lead.confirmation == 'T') {
					lead.confirmation = 'CONFIRMED';
				} else {
					lead.confirmation = '';
				}

				if (lead.calificado === 'T') {
					lead.calificado = 'GOOD';
				} else {
					lead.calificado = 'BAD';
				}
			}

			this.totalApproved = this.approved.length;
			this.totalDenied = this.denied.length;
			this.totalFix = this.fix.length;
			this.leadsLoading = false;
			this.getAllUnreviewed();
		});
	}

	getAllUnreviewed() {
		this.leadSrv.getAllUnreviewed().subscribe((data: any) => {
			this.unreviewed = [];
			this.overproduced = [];

			for (let lead of data.body) {
				lead.class = {
					class: 'bg-info',
					key: 'prospect_company',
				};

				if (lead.payed == 'T') {
					lead.payed = this.sanitizer.bypassSecurityTrustHtml(
						`<i class="ri-checkbox-line"></i>`,
					);
				} else {
					lead.payed = this.sanitizer.bypassSecurityTrustHtml(
						`<i class="ri-checkbox-blank-line"></i>`,
					);
				}

				switch (lead.difficult) {
					case 'Easy':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-success" aria-hidden="true"></i>`,
							);
						break;
					case 'Medium':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-warning" aria-hidden="true"></i>`,
							);
						break;

					case 'Hard':
						lead.difficult =
							this.sanitizer.bypassSecurityTrustHtml(
								`<i class="ri-flag-2-fill text-danger" aria-hidden="true"></i>`,
							);
						break;

					default:
						break;
				}

				lead.meet_type_label = lead.calendar_type || '-';

				if (lead.calificado === 'T') {
					lead.calificado = 'GOOD';
				} else {
					lead.calificado = 'BAD';
				}

				// Normalizar confirmación
				if (lead.confirmation === 'T') {
					lead.confirmation = 'CONFIRMED';
				} else {
					lead.confirmation = '';
				}

				if (lead.overproduced === 'T') {
					lead.stage = 'overproduced';
					this.overproduced.push(lead);
				} else {
					lead.stage = 'review';
					this.unreviewed.push(lead);
				}
			}

			this.totalOverproduced = this.overproduced.length;
			this.totalUnreviewed = this.unreviewed.length;

			this.toggleLeadsList(this.currentTab);
		});
	}

	toggleLeadsList(type: string) {
		this.leads = [];

		switch (type) {
			case 'review':
				this.leads = this.unreviewed;
				this.leadsMsg = this.unreviewedLeadsMsg;
				break;
			case 'fix':
				this.leads = this.fix;
				this.leadsMsg = this.rescheduleLeadsMsg;
				break;
			case 'approved':
				this.leads = this.approved;
				this.leadsMsg = this.approvedLeadsMsg;
				break;
			case 'overproduced':
				this.leads = this.overproduced;
				this.leadsMsg = this.rescheduleLeadsMsg;
				break;
			case 'denied':
				this.leads = this.denied;
				this.leadsMsg = this.deniedLeadsMsg;
				break;
			case 'billing':
			case 'cleared':
			case 'released':
				// TODO: sin fuente de datos aún — falta que el backend exponga lead.stage
				this.leads = [];
				break;
			default:
				this.leads = [];
		}

		this.selectedOptions.qcControl.selectedTab = type;
	}

	trackByLeadId(index: number, lead: any): number {
		return lead.id;
	}

	caps() {
		return {
			releaseBilling: true,
		};
	}

	trackByValue(index: number, value: any): any {
		return value;
	}

	setRole(role: any): void {}

	setTab(value: string): void {
		this.currentTab = value;
		this.toggleLeadsList(value);
		this.syncUrl();
	}

	counts() {
		return {
			review: this.totalUnreviewed ?? 0,
			billing: 0,
			cleared: 0,
			released: 0,
			fix: this.totalFix ?? 0,
			approved: this.totalApproved ?? 0,
			overproduced: this.totalOverproduced ?? 0,
			denied: this.totalDenied ?? 0,
		};
	}

	isColumnVisible(prop: string): boolean {
		const col = this.columns.find((c) => c.prop === prop);
		return col ? col.visible : true;
	}

	apptTypeMap = APPT_TYPES.reduce(
		(acc, item) => {
			acc[item.id] = item.description;
			return acc;
		},
		{} as Record<number, string>,
	);

	get filteredLeads(): any[] {
		const term = this.searchTerm.trim().toLowerCase();
		if (!term) return this.leads;

		return this.leads.filter((lead) => [lead.id, lead.first_name, lead.prospect_company, lead.campaign_name, lead.primary_phone].some((field) => (field || '').toString().toLowerCase().includes(term)));
	}

	dateSelected(dates: any): void {
		this.selectedOptions.qcControl.fromDate = dayjs(dates.dateStart).format('YYYY-MM-DD') + ' 00:00:00';
		this.selectedOptions.qcControl.toDate = dayjs(dates.dateEnd).format('YYYY-MM-DD') + ' 23:59:59';
		this.syncUrl();
		this.selectSearch();
	}

	get visibleColumnsCount(): number {
		return this.columns.filter((c) => c.visible).length + 1; // +1 por la columna de acción, que no tiene ngIf
	}

	open(id: number): void {
		this.selectedLead = this.leads.find((l) => l.id === id) || null;
		this.fixReason = '';
		this.selectedDisposition = '';
	}

	close(): void {
		this.selectedLead = null;
	}

	reopen(id: number): void {
		const lead = this.leads.find((l) => l.id === id);
		if (lead) {
			lead.stage = 'review';
			lead.lead_status = 'Unreviewed';
		}
	}
	approveAndRelease(): void {
		if (!this.selectedLead) return;
		this.selectedLead.stage = 'released';
		this.selectedLead.billingDisposition = this.dispositionLabels[this.selectedDisposition] || '';
		this.close();
	}

	sendToFix(): void {
		const lead = this.selectedLead;
		if (!lead) return;

		const payload = { lead_id: lead.id, user: this.user.Login, user_id: this.user.IdUser };

		this.leadSrv.fixLead(payload).subscribe(
			() => {
				Swal.fire({ icon: 'success', title: 'Lead Correctly set to Fix' });
				lead.lead_status = 'Fix';
				lead.stage = 'fix';
				this.moveLeadToFix(lead);
				this.close();
			},
			(error: any) => {
				Swal.fire({ icon: 'error', title: 'Error changing lead status to fix ', text: 'See the console for further information' });
				console.error('Error approving lead:', error);
			},
		);
	}
	private moveLeadToFix(lead: any): void {
		const removeFrom = (arr: any[]) => {
			const idx = arr.indexOf(lead);
			if (idx > -1) arr.splice(idx, 1);
		};

		removeFrom(this.unreviewed);
		removeFrom(this.overproduced);
		removeFrom(this.denied);
		removeFrom(this.approved);

		if (!this.fix.includes(lead)) {
			this.fix.push(lead);
		}

		this.totalUnreviewed = this.unreviewed.length;
		this.totalOverproduced = this.overproduced.length;
		this.totalDenied = this.denied.length;
		this.totalApproved = this.approved.length;
		this.totalFix = this.fix.length;
	}

	reserveDisabled(): boolean {
		return false; // TODO: sin lógica real de reserva todavía
	}

	band(score: number): { color: string } {
		if (score >= 80) return { color: '#16A34A' };
		if (score >= 50) return { color: '#D97706' };
		return { color: '#DC2626' };
	}

	ringDash(score: number): string {
		const circumference = 2 * Math.PI * 16;
		const filled = (score / 100) * circumference;
		return `${filled} ${circumference}`;
	}

	trackByReasonText(index: number, reason: any): string {
		return reason.text;
	}

	private applyFiltersFromUrl(): void {
		const params = this.route.snapshot.queryParamMap;

		const tab = params.get('tab');
		if (tab) this.currentTab = tab;

		const q = params.get('q');
		if (q) this.searchTerm = q;

		const from = params.get('from');
		const to = params.get('to');
		if (from && to) {
			this.selectedOptions.qcControl.fromDate = from + ' 00:00:00';
			this.selectedOptions.qcControl.toDate = to + ' 23:59:59';
			this.dateRange_ = {
				dateStart: dayjs(from),
				dateEnd: dayjs(to),
			};
		}
	}

	private syncUrl(): void {
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: {
				tab: this.currentTab,
				q: this.searchTerm || null,
				from: dayjs(this.selectedOptions.qcControl.fromDate).format('YYYY-MM-DD'),
				to: dayjs(this.selectedOptions.qcControl.toDate).format('YYYY-MM-DD'),
			},
			queryParamsHandling: 'merge',
			replaceUrl: true,
		});
	}

	onSearchChange(): void {
		this.syncUrl();
	}

	openLead(lead: any): void {
		this.router.navigateByUrl('/lead-edit/' + lead.id);
	}

	// approveLeadById(): void {
	// 	const lead = this.selectedLead;
	// 	if (!lead) return;

	// 	if (lead.lead_status == 'Approved') {
	// 		Swal.fire({
	// 			title: 'Already Approved',
	// 			text: 'This lead is already approved',
	// 			showCancelButton: false,
	// 			confirmButtonText: 'Ok',
	// 		});
	// 		return;
	// 	}

	// 	this.leadSrv.getLeadCampaign(lead.id).then((data: any) => {
	// 		this.getOrderData(data.body.id, lead);
	// 	});
	// }

	private getOrderData(campaignId: number, lead: any, onApproved: () => void): void {
		this.orderSrv.getDataOrderByCampaign_all(campaignId).subscribe((data: any) => {
			if (!data.hasOwnProperty('error')) {
				if (data.body.length > 0) {
					const order_info = data.body;
					if (order_info[0].type_orderid == '1') {
						this.getRemainingLeads(order_info[0].id, order_info[0].status_orderid, onApproved);
					}
					if (order_info[0].type_orderid == '3') {
						this.getRemainingHours(campaignId, order_info[0].start_date, order_info[0].status_orderid, order_info[0].total_hours, order_info[0].id, onApproved);
					}
				} else {
					onApproved();
				}
			}
		});
	}

	private getRemainingLeads(id: number, status: any, onApproved: () => void): void {
		this.orderSrv.getRemainingLeads(id).subscribe((data: any) => {
			if (!data.hasOwnProperty('error')) {
				if (data.body.records.length > 0) {
					const remaining = parseInt(data.body.records[0].remaining_total) - 1;

					if (status == '2' || status == '4') {
						if (remaining == 0) {
							this.orderSrv.change_status_order(id, 4, null, 0, this.user.IdUser, 1).subscribe(() => {
								onApproved();
							});
						}
						if (remaining < 0) {
							Swal.fire({
								title: 'Message',
								text: 'The campaign is complete, do you want to save another lead?',
								showCancelButton: true,
								confirmButtonText: 'Yes',
								cancelButtonText: 'Cancel',
							}).then((result) => {
								if (result.value) {
									this.orderSrv.change_status_order(id, 7, null, null, this.user.IdUserUser, 1);
									onApproved();
								}
							});
						} else if (remaining > 0) {
							onApproved();
						}
					} else if (status == 7) {
						onApproved();
					} else {
						Swal.fire({
							title: 'Message',
							text: "The order is closed, in this case the lead doesn't can approveded.",
							showCancelButton: false,
							confirmButtonText: 'Yes',
						});
					}
				}
			}
		});
	}

	private getRemainingHours(campaign: number, start_date: any, status: any, total_hours: any, orden: number, onApproved: () => void): void {
		this.orderSrv.getHoursCampaign(campaign, start_date).subscribe((data: any) => {
			if (data.body.records.length > 0) {
				const remaining = parseInt(total_hours) - parseFloat(data.body.records[0].sum_time);

				if (status == '2' || status == '4') {
					if (remaining == 0) {
						this.orderSrv.change_status_order(orden, 4, null, 0, this.user.IdUser, 3).subscribe(() => {
							onApproved();
						});
					}
					if (remaining < 0) {
						Swal.fire({
							title: 'Message',
							text: 'The campaign is complete, do you want to save another lead?',
							showCancelButton: true,
							confirmButtonText: 'Yes',
							cancelButtonText: 'Cancel',
						}).then((result) => {
							if (result.value) {
								this.orderSrv.change_status_order(orden, 7, null, null, this.user.IdUser, 3);
								onApproved();
							}
						});
					} else {
						onApproved();
					}
				} else if (status == 7) {
					onApproved();
				} else {
					Swal.fire({
						title: 'Message',
						text: "The order is closed, in this case the lead doesn't can approveded.",
						showCancelButton: false,
						confirmButtonText: 'Yes',
					});
				}
			}
		});
	}

	private requestApprovedLead(lead: any): void {
		const payload = { lead_id: lead.id, user: this.user.Login, user_id: this.user.IdUser };
		this.leadSrv.approve_lead(payload).subscribe(
			() => {
				Swal.fire({ icon: 'success', title: 'Lead Correctly approved' });
				lead.lead_status = 'Approved';
				lead.stage = 'released';
				this.moveLeadToApproved(lead);
				this.close();
			},
			(error: any) => {
				Swal.fire({ icon: 'error', title: 'Error approving lead', text: 'See the console for further information' });
				console.error('Error approving lead:', error);
			},
		);
	}

	onApproveClick(): void {
		if (!this.selectedLead || !this.selectedDisposition) return;
		const lead = this.selectedLead;
		const disposition = this.selectedDisposition;
		const id = lead.id;

		if (disposition === 'charge') {
			Swal.fire({
				title: 'Confirm',
				text: `Are you sure you want to approve lead ${id}?`,
				showCancelButton: true,
				confirmButtonText: 'Yes, approve',
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.value) this.approveLeadById(lead);
			});
		} else {
			const label = this.dispositionLabels[disposition];
			Swal.fire({
				title: 'Confirm',
				text: `Are you sure you want to approve and release lead ${id} as ${label}?`,
				showCancelButton: true,
				confirmButtonText: 'Yes, approve & release',
				cancelButtonText: 'Cancel',
			}).then((result) => {
				if (result.value) this.approveAndReleaseLead(lead, disposition);
			});
		}
	}

	approveLeadById(lead: any): void {
		if (!lead) return;

		if (lead.lead_status == 'Approved') {
			Swal.fire({ title: 'Already Approved', text: 'This lead is already approved', showCancelButton: false, confirmButtonText: 'Ok' });
			return;
		}

		this.leadSrv.getLeadCampaign(lead.id).then((data: any) => {
			this.getOrderData(data.body.id, lead, () => this.requestApprovedLead(lead));
		});
	}

	approveAndReleaseLead(lead: any, disposition: string): void {
		if (!lead) return;

		if (lead.lead_status == 'Approved') {
			Swal.fire({ title: 'Already Approved', text: 'This lead is already approved', showCancelButton: false, confirmButtonText: 'Ok' });
			return;
		}

		this.leadSrv.getLeadCampaign(lead.id).then((data: any) => {
			this.getOrderData(data.body.id, lead, () => this.approveThenMarkBilling(lead, disposition));
		});
	}

	private approveThenMarkBilling(lead: any, disposition: string): void {
		const payload = { lead_id: lead.id, user: this.user.Login, user_id: this.user.IdUser };
		this.leadSrv.approve_lead(payload).subscribe(
			() => {
				lead.lead_status = 'Approved';
				this.markBillingDisposition(lead, disposition);
			},
			(error: any) => {
				Swal.fire({ icon: 'error', title: 'Error approving lead', text: 'See the console for further information' });
				console.error('Error approving lead:', error);
			},
		);
	}

	private markBillingDisposition(lead: any, disposition: string): void {
		const freeTypeMap: any = { reserve: 'Reserve', promo: 'Promo', hourly: 'Hourly' };
		if (disposition === 'paid') {
			this.setPayedLead(lead);
		} else {
			this.setFreeLead(lead, freeTypeMap[disposition]);
		}
	}
	// private setFreeLead(lead: any, free_type: string): void {
	// 	const payload = {
	// 		leadId: lead.id,
	// 		employee: this.user.Login,
	// 		free_type: free_type,
	// 		prospect_company: lead.prospect_company,
	// 		appt_date: lead.date_generated,
	// 	};

	// 	Swal.fire({
	// 		title: 'Set as Free',
	// 		text: '',
	// 		confirmButtonText: 'Ok',
	// 		didOpen: () => {
	// 			Swal.showLoading();
	// 			this.billingSrv.setAsFree(payload).subscribe(() => {
	// 				lead.stage = 'released';
	// 				lead.billingDisposition = free_type;
	// 				this.moveLeadToApproved(lead);
	// 				this.close();
	// 				Swal.fire({ title: 'Success', text: 'The lead was charged successfuly', showCancelButton: false, confirmButtonText: 'Ok', cancelButtonText: 'Cancel' });
	// 			});
	// 		},
	// 	});
	// }

		private setFreeLead(lead: any, free_type: string): void {
		const payload = {
			leadId: lead.id,
			employee: this.user.Login,
			free_type: free_type,
			prospect_company: lead.prospect_company,
			appt_date: lead.date_generated,
			user_id: this.user.IdUser,
		};

		Swal.fire({
			title: 'Set as Free',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.billingSrv.setAsFree(payload).subscribe({
					next: () => {
						lead.stage = 'released';
						lead.billingDisposition = free_type;
						this.moveLeadToApproved(lead);
						this.close();
						Swal.fire({ title: 'Success', text: 'The lead was charged successfuly', showCancelButton: false, confirmButtonText: 'Ok', cancelButtonText: 'Cancel' });
					},
					error: (err) => {
						const message = typeof err === 'string' ? err : err?.error?.message || '';

						this.moveLeadToApproved(lead);
						this.close();

						if (message.includes('Insufficient reserve balance')) {
							Swal.fire({
								title: 'Approved, but not released',
								icon: 'warning',
								html: `Lead ${lead.id} was approved, but it couldn't be released as Reserve because the campaign doesn't have enough funds.<br><br><strong>${message.replace('Insufficient reserve balance. ', '')}</strong><br><br>Add a deposit from <strong>Campaigns → Action → Reserve</strong>, then release it from <strong>Billing → Charge</strong>.`,
								confirmButtonText: 'Ok',
							});
						} else {
							Swal.fire({
								title: 'Approved, but not released',
								icon: 'error',
								text: `Lead ${lead.id} was approved, but it couldn't be set as free: ${message || 'unknown error'}. You can release it from Billing → Charge.`,
								confirmButtonText: 'Ok',
							});
						}
					},
				});
			},
		});
	}

	// private setPayedLead(lead: any, selectedUser: any): void {
	// 	Swal.fire({
	// 		title: 'Sending Email',
	// 		text: '',
	// 		confirmButtonText: 'Ok',
	// 		didOpen: () => {
	// 			Swal.showLoading();
	// 			this.billingSrv.getNotPayedLeads().subscribe((data: any) => {
	// 				const match = data.body.find((l: any) => l.lead_id === lead.id || l.id === lead.id);
	// 				const leadCost = match ? match.lead_cost : undefined;

	// 				const payload = {
	// 					user_id: selectedUser.id,
	// 					leadId: lead.id,
	// 					normal_amount: leadCost,
	// 					paidBy: lead.generated_by,
	// 					employee: this.user.Login,
	// 					prospect_company: lead.prospect_company,
	// 					appt_date: lead.date_generated,
	// 				};
	// 				this.billingSrv.setAsPayed(payload).subscribe(() => {
	// 					Swal.close();
	// 					lead.stage = 'released';
	// 					lead.billingDisposition = 'Paid';
	// 					this.moveLeadToApproved(lead);
	// 					this.close();
	// 					Swal.fire({ title: 'Success', text: 'The lead was charged successfuly', showCancelButton: false, confirmButtonText: 'Ok', cancelButtonText: 'Cancel' });
	// 				});
	// 			});
	// 		},
	// 	});
	// }
	private moveLeadToApproved(lead: any): void {
		const removeFrom = (arr: any[]) => {
			const idx = arr.indexOf(lead);
			if (idx > -1) arr.splice(idx, 1);
		};

		removeFrom(this.unreviewed);
		removeFrom(this.fix);
		removeFrom(this.overproduced);
		removeFrom(this.denied);

		if (!this.approved.includes(lead)) {
			this.approved.push(lead);
		}

		this.totalUnreviewed = this.unreviewed.length;
		this.totalFix = this.fix.length;
		this.totalOverproduced = this.overproduced.length;
		this.totalDenied = this.denied.length;
		this.totalApproved = this.approved.length;
	}

	private setPayedLead(lead: any): void {
		Swal.fire({
			title: 'Sending Email',
			text: '',
			confirmButtonText: 'Ok',
			didOpen: () => {
				Swal.showLoading();
				this.billingSrv.getNotPayedLeads().subscribe((data: any) => {
					const match = data.body.find((l: any) => l.lead_id === lead.id || l.id === lead.id);
					const alias = match ? match.alias : undefined;
					const leadCost = match ? match.lead_cost : undefined;

					this.userSrv.getUserByAlias(alias).subscribe((userData: any) => {
						if (!userData || !userData.body) {
							Swal.close();
							Swal.fire({ icon: 'error', title: 'Error', text: `No se encontró el usuario para el alias "${alias}"` });
							return;
						}
						const selectedUser = userData.body;
						const payload = {
							user_id: selectedUser.id,
							leadId: lead.id,
							normal_amount: leadCost,
							paidBy: alias,
							employee: this.user.Login,
							prospect_company: lead.prospect_company,
							appt_date: lead.date_generated,
						};
						this.billingSrv.setAsPayed(payload).subscribe(() => {
							Swal.close();
							lead.stage = 'released';
							lead.billingDisposition = 'Paid';
							this.moveLeadToApproved(lead);
							this.close();
							Swal.fire({ title: 'Success', text: 'The lead was charged successfuly', showCancelButton: false, confirmButtonText: 'Ok', cancelButtonText: 'Cancel' });
						});
					});
				});
			},
		});
	}

	denyLead(): void {
		const lead = this.selectedLead;
		if (!lead) return;

		const payload = { lead_id: lead.id, user: this.user.Login, campaign_id: lead.campaign_id, user_id: this.user.IdUser };

		this.leadSrv.denyLead(payload).subscribe(
			() => {
				Swal.fire({ icon: 'success', title: 'Lead Correctly Denied' });
				lead.lead_status = 'Denied';
				lead.stage = 'denied';
				this.moveLeadToDenied(lead);
				this.close();
			},
			(error: any) => {
				Swal.fire({ icon: 'error', title: 'Error denying lead ', text: 'See the console for further information' });
				console.error('Error denying lead:', error);
			},
		);
	}

	private moveLeadToDenied(lead: any): void {
		const removeFrom = (arr: any[]) => {
			const idx = arr.indexOf(lead);
			if (idx > -1) arr.splice(idx, 1);
		};

		removeFrom(this.unreviewed);
		removeFrom(this.fix);
		removeFrom(this.overproduced);
		removeFrom(this.approved);

		if (!this.denied.includes(lead)) {
			this.denied.push(lead);
		}

		this.totalUnreviewed = this.unreviewed.length;
		this.totalFix = this.fix.length;
		this.totalOverproduced = this.overproduced.length;
		this.totalApproved = this.approved.length;
		this.totalDenied = this.denied.length;
	}

	getMeetTypeName(typeId: number | string): string {
		return APPT_TYPES.find((t) => t.id === Number(typeId))?.name || '';
	}

	getMeetTypeClass(typeId: number): string {
		switch (this.getMeetTypeName(typeId)) {
			case 'phone':
				return 'meet-type-phone';
			case 'face_to_face':
				return 'meet-type-f2f';
			case 'zoom':
				return 'meet-type-zoom';
			default:
				return '';
		}
	}

	getMeetTypeIcon(typeId: number): string {
		switch (this.getMeetTypeName(typeId)) {
			case 'face_to_face':
				return 'ri-service-fill';
			case 'phone':
				return 'ri-phone-fill';
			case 'zoom':
				return 'ri-macbook-fill';
			default:
				return '';
		}
	}

	openLeadById(id: number | string | null): void {
		if (!id) return;
		this.router.navigateByUrl('/lead-edit/' + id);
	}

	getReplacedById(value: string): number | null {
		if (!value) return null;
		const match = value.match(/^\d+/);
		return match ? parseInt(match[0], 10) : null;
	}

	getDifficultyIconClass(difficulty: string): string {
		switch (difficulty) {
			case 'Easy':
				return 'text-success';
			case 'Medium':
				return 'text-warning';
			case 'Hard':
				return 'text-danger';
			default:
				return '';
		}
	}
}
